namespace Matrix.Data {
    export interface ModelForm {
        ModelCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        IsPercent: Serenity.BooleanEditor;
        Levels: Serenity.IntegerEditor;
        LevelName1: Serenity.StringEditor;
        LevelName2: Serenity.StringEditor;
        LevelName3: Serenity.StringEditor;
        LevelName4: Serenity.StringEditor;
        LevelName5: Serenity.StringEditor;
        LevelName6: Serenity.StringEditor;
        LevelName7: Serenity.StringEditor;
        LevelName8: Serenity.StringEditor;
        LevelName9: Serenity.StringEditor;
        LevelName10: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ModelForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Model';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModelForm.init)  {
                ModelForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(ModelForm, [
                    'ModelCode', w0,
                    'Name', w0,
                    'IsPercent', w1,
                    'Levels', w2,
                    'LevelName1', w0,
                    'LevelName2', w0,
                    'LevelName3', w0,
                    'LevelName4', w0,
                    'LevelName5', w0,
                    'LevelName6', w0,
                    'LevelName7', w0,
                    'LevelName8', w0,
                    'LevelName9', w0,
                    'LevelName10', w0,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
